// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"612":"ce335717c117ec112980","756":"0b9f3e2a6ba9f2b3c9f1"}[chunkId] + ".js";
};